import ModalLogin from "./ModalLogin"
import ModalRegister from "./ModalRegister"
import withAccountHOC from "./withAccountHOC";

export {
    ModalLogin,
    ModalRegister,
    withAccountHOC
}


// WEBPACK FOOTER //
// ./src/components/account/index.ts